import { render, staticRenderFns } from "./MarkdownWindow.vue?vue&type=template&id=3575b5fc&scoped=true&"
import script from "./MarkdownWindow.vue?vue&type=script&lang=js&"
export * from "./MarkdownWindow.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownWindow.vue?vue&type=style&index=0&id=3575b5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575b5fc",
  null
  
)

export default component.exports